import { jsx as o } from "react/jsx-runtime";
import { InputRightElement as e } from "@chakra-ui/react";
import "../Button/Button.mjs";
import { IconButton as i } from "../Button/IconButton.mjs";
import "../Button/ButtonGroup.mjs";
import { EyeSlashIcon as s, EyeIcon as l } from "../../icons/componentIcons.mjs";
const g = ({
  isDisabled: t = !1,
  isPasswordShown: r = !1,
  ...a
}) => /* @__PURE__ */ o(e, { className: "password-view-toggle", children: /* @__PURE__ */ o(
  i,
  {
    "aria-label": "Show password",
    icon: r ? /* @__PURE__ */ o(s, { variant: "solid" }) : /* @__PURE__ */ o(l, { variant: "solid" }),
    isDisabled: t,
    role: "switch",
    "aria-checked": r,
    ...a,
    variant: "ghost"
  }
) });
export {
  g as PasswordToggleButton
};
